/* ============================================================
   MAISON MOLIER — mm-swatch.js v1
   Kleur-swatch wissel zonder page-reload (progressive enhancement)
   ------------------------------------------------------------
   - Swatch-links blijven echte links: SEO en deelbare URL's intact
   - Hover/touch = prefetch van de andere kleur (voelt instant)
   - Klik = alleen het productgedeelte wisselen + URL/titel bijwerken
   - Terug/vooruit-knop werkt; bij elke fout: normale navigatie
   ============================================================ */
(function () {
  'use strict';

  var MAIN_SEL = 'main#main';
  var LINK_SEL = '.shopify-section--main-product a.color-swatch[href*="/products/"]';

  if (!document.querySelector('.shopify-section--main-product')) return;

  var cache = new Map();
  var navToken = 0;
  var lastPath = location.pathname;

  function fetchPage(url) {
    if (!cache.has(url)) {
      var p = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .catch(function (err) {
          cache.delete(url);
          throw err;
        });
      cache.set(url, p);
    }
    return cache.get(url);
  }

  /* Ingevoegde <script>-tags voeren niet vanzelf uit; hier her-activeren
     (JSON-datascripts slaan we over, die hoeven niet te draaien). */
  function executeScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || 'text/javascript').toLowerCase();
      if (type.indexOf('json') !== -1) return;
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) {
        s.setAttribute(a.name, a.value);
      });
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function renderPage(html, url, push) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector(MAIN_SEL);
    var cur = document.querySelector(MAIN_SEL);
    if (!next || !cur) {
      window.location.href = url;
      return;
    }
    cur.replaceChildren();
    while (next.firstChild) cur.appendChild(next.firstChild);
    executeScripts(cur);
    document.title = doc.title;
    if (push) history.pushState({ mmSwatch: true }, '', url);
    lastPath = new URL(url, location.origin).pathname;
    document.dispatchEvent(
      new CustomEvent('mm:product-swapped', { detail: { url: url } })
    );
  }

  /* --- Prefetch bij hover / touch / toetsenbord-focus --- */
  ['pointerover', 'touchstart', 'focusin'].forEach(function (evt) {
    document.addEventListener(
      evt,
      function (e) {
        var link = e.target.closest && e.target.closest(LINK_SEL);
        if (link && !link.classList.contains('is-selected')) {
          fetchPage(link.href).catch(function () {});
        }
      },
      { passive: true }
    );
  });

  /* --- Klik: wisselen zonder reload --- */
  document.addEventListener('click', function (e) {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
    ) {
      return;
    }
    var link = e.target.closest && e.target.closest(LINK_SEL);
    if (!link) return;

    e.preventDefault();
    if (link.classList.contains('is-selected')) return;

    /* Directe visuele feedback: ring meteen verplaatsen */
    var group = link.closest('.variant-picker__option-values');
    if (group) {
      group.querySelectorAll('.color-swatch').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      link.classList.add('is-selected');
    }
    var section = document.querySelector('.shopify-section--main-product');
    if (section) {
      section.style.transition = 'opacity .15s ease';
      section.style.opacity = '0.5';
    }

    var url = link.href;
    var token = ++navToken;

    fetchPage(url)
      .then(function (html) {
        if (token !== navToken) return;
        renderPage(html, url, true);
      })
      .catch(function () {
        window.location.href = url; /* vangnet: gewone navigatie */
      })
      .finally(function () {
        var sec = document.querySelector('.shopify-section--main-product');
        if (sec) sec.style.opacity = '';
      });
  });

  /* --- Terug/vooruit-knop: zelfde swap, anders reload --- */
  window.addEventListener('popstate', function () {
    if (location.pathname === lastPath) return; /* alleen hash/scroll */
    fetchPage(location.href)
      .then(function (html) {
        renderPage(html, location.href, false);
      })
      .catch(function () {
        location.reload();
      });
  });
})();
